import { Routes } from '@/router/routes'
import type { RouteLocationGeneric } from 'vue-router'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const dailyAgendaRoutes = [
  {
    path: '/daily-agenda',
    name: Routes.DailyAgenda,
    component: () => import('@/pages/contexts/portal/daily-agenda-v2/Index.vue'),
    meta: {
      pageTitle: 'Daily Agenda',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_DAILY_AGENDA,
    },
  },
  {
    path: '/daily-agenda/:date(\\d{4}-\\d{2}-\\d{2})',
    redirect: (to: RouteLocationGeneric) => ({
      name: Routes.DailyAgenda,
      query: {
        ...to.query,
        startDate: String(to.params.date),
        endDate: String(to.params.date),
      },
    }),
  },
  {
    path: '/daily-agenda-classic/:date(\\d{4}-\\d{2}-\\d{2})?',
    name: Routes.DailyAgendaClassic,
    component: () => import('@/pages/contexts/portal/daily-agenda/Index.vue'),
    meta: {
      pageTitle: 'Daily Agenda Classic',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_DAILY_AGENDA,
    },
  },
]
